import { render, staticRenderFns } from "./TemasComponent.vue?vue&type=template&id=d4b7f450"
import script from "./TemasComponent.vue?vue&type=script&lang=js"
export * from "./TemasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports